import { render, staticRenderFns } from "./BomBatchReg.vue?vue&type=template&id=f9add124&"
import script from "./BomBatchReg.vue?vue&type=script&lang=js&"
export * from "./BomBatchReg.vue?vue&type=script&lang=js&"
import style0 from "./BomBatchReg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports